module.exports = __webpack_public_path__ + "assets/images/14593f2b0ea0f6dc86040c0144b74f26.svg";